import * as yup from 'yup';
import { TFunction } from 'i18next';

export const fields = [
  'transactionType',
  'transactionDate',
  'paymentStatus',
  'payeeAccountName',
  'country',
  'receivingPartyCurreny',
  'settlementCurrency',
  'settlementExchangeRate',
  'claimsPaymentSource',
  'fromBankAccount',
] as const;

export type PaymentReserveChangeFormFields = (typeof fields)[number];

export const getValidationSchema = (t: TFunction) =>
  yup.object().shape({
    transactionType: yup.string().required(
      t('validation.required', {
        field: t('claim.paymentReserveChange.transactionType'),
      })
    ),
    transactionDate: yup.mixed().required(
      t('validation.required', {
        field: t('claim.paymentReserveChange.transactionDate'),
      })
    ),
    paymentStatus: yup.string().required(
      t('validation.required', {
        field: t('claim.paymentReserveChange.paymentStatus'),
      })
    ),
    payeeAccountName: yup.string().required(
      t('validation.required', {
        field: t('claim.paymentReserveChange.payeeAccountName'),
      })
    ),
    country: yup
      .string()
      .required(t('validation.required', { field: t('general.country') })),
    receivingPartyCurreny: yup.string().required(
      t('validation.required', {
        field: t('claim.paymentReserveChange.receivingPartyCurreny'),
      })
    ),
    settlementCurrency: yup.string().required(
      t('validation.required', {
        field: t('claim.paymentReserveChange.settlementCurrency'),
      })
    ),
    settlementExchangeRate: yup
      .string()
      .required(
        t('validation.required', {
          field: t('claim.paymentReserveChange.settlementExchangeRate'),
        })
      )
      .test(
        'positive',
        t('validation.numericPositive', {
          field: t('claim.paymentReserveChange.settlementExchangeRate'),
        }),
        (value) => !value || Number(value) > 0
      ),
    claimsPaymentSource: yup.string().required(
      t('validation.required', {
        field: t('claim.paymentReserveChange.claimsPaymentSource'),
      })
    ),
    fromBankAccount: yup.string().required(
      t('validation.required', {
        field: t('claim.paymentReserveChange.fromBankAccount'),
      })
    ),
  });
